import { type ReactNode } from "react";
import { atom } from "nanostores";

import type { NavigationItem } from "./Sidebar.types";

export const $subNavigationItem = atom<NavigationItem | undefined>(undefined);
export const $subNavigationNode = atom<ReactNode | undefined>(undefined);
export const $subNavigationItems = atom<NavigationItem[]>([]);

export const subNavigationActions = {
  setActiveItem: (item: NavigationItem | undefined) =>
    $subNavigationItem.set(item),
  clearActiveItem: () => $subNavigationItem.set(undefined),
  setSubNav: ({
    node,
    items,
  }: {
    node?: ReactNode;
    items: NavigationItem[];
  }) => {
    $subNavigationNode.set(node);
    $subNavigationItems.set(items);
  },
  clean: () => {
    $subNavigationItem.set(undefined);
    $subNavigationNode.set(undefined);
    $subNavigationItems.set([]);
  },
};
